import "./styles/image-rating.scss";
import ImageRating from "./js/ImageRating";
import ImageRatingView from "./js/ImageRatingView"

export default ImageRating;
export { ImageRatingView };
